export default __webpack_public_path__ + "static/media/lifesatisfaction5Img1.40ed7ae7.png";